import React, { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';

// Components
import Breadcrumb from '../../container/breadcrumb';
import HeaderActions from '../../container/header_actions';
import PeriodBreadcrumb from '../../component/PeriodBreadcrumb';
import ConditionalRender from '../../helpers/ConditionalRender';
import PageContent from '../../container/page_content';

// Constants
import { DATA_LOADING } from '../../component/Constants';

interface ClustersTabbedProps {
    clusterId: number;
    clusterName: string;
    groupName?: string;
    toggleMenu: Function;
    refresh: () => void;
    loading?: number;
    activeTab: 'overview' | 'group';
    title: string;
    description: string;
    children: ReactNode;
}

const ClustersTabbed: React.FC<ClustersTabbedProps> = ({
    clusterId,
    clusterName,
    groupName,
    toggleMenu,
    refresh,
    loading,
    activeTab,
    title,
    description,
    children
}) => {
    return (
        <PageContent title={title} description={description}>
            {/* Heading */}
            <div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
                <Breadcrumb heading={groupName ?? clusterName}>
                    <Link to="/clusters">Analysis</Link>
                    <Link to="/clusters">Clusters</Link>
                    <Link to={`/clusters/${clusterId}`}>{clusterName}</Link>
                    <NavLink to={`/clusters/${clusterId}`} className={"current-breadcrumb-link"}>
                        {activeTab === 'overview' && 'Overview'}
                        {activeTab === 'group' && (groupName ?? '')}
                    </NavLink>
                    <PeriodBreadcrumb />
                </Breadcrumb>
                <HeaderActions
                    toggleMenu={toggleMenu}
                    refresh={refresh}
                />
            </div>

            <div className="loader">
                <ConditionalRender if={loading === DATA_LOADING}>
                    <div className="bar"/>
                </ConditionalRender>
            </div>

            {/* Page Content */}
            {children}
        </PageContent>
    );
};

export default ClustersTabbed;
